import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import CreateProjectUserForm from "../components/ProjectUserCreate";

export default function ProjectUserCreateScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation("user");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("userCreateScreen.title")}>
                <CreateProjectUserForm
                    onSubmitted={() => {
                        navigate(`..`);
                    }}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
